<ng-container *ngIf="
    !loading &&
    !isTokenized &&
    actionType !== 'Add' &&
    actionType !== undefined &&
    moduleId !== 10023 &&
    (groupedActions.length > 0 || ungroupedActions.length > 0)
  ">
  <ng-container *ngIf="!inLine && ((!actionsExpanded) || (actionsExpanded && displayMode === 'cards'))">
    <a nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" *ngIf="inList" style="width: 100; display: block">
      <i class="far fa-ellipsis"></i>
    </a>
    <button nz-button nz-dropdown [nzDropdownMenu]="menu" *ngIf="!inList">
      <i class="fal fa-bolt"></i>
      <span class="xs-h s-h">{{ "Actions" | locale }}</span>
    </button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <ng-container *ngFor="let group of groupedActions">
          <li nz-submenu [nzTitle]="group.key | locale">
            <ul>
              <ng-container *ngFor="let action of group.actions">
                <li nz-menu-item *ngIf="action.ActionUrls.length == 1" (click)="executeAction(action.ActionUrls[0])">
                  <i [class]="action.ActionUrls[0].Icon"></i>&nbsp;
                  {{ action.Name | locale }}
                </li>
                <li nz-submenu *ngIf="action.ActionUrls.length > 1" [nzTitle]="action.Name | locale">
                  <ul>
                    <li nz-menu-item *ngFor="let url of action.ActionUrls"
                      (click)="executeAction(action.ActionUrls[0])">
                      <i [class]="url.Icon"></i>&nbsp;
                      {{ url.Text | locale }}
                    </li>
                  </ul>
                </li>
              </ng-container>
            </ul>
          </li>
        </ng-container>
        <ng-container *ngFor="let action of ungroupedActions">
          <li nz-menu-item (click)="executeAction(action.ActionUrls[0])" *ngIf="action.ActionUrls.length == 1 && !removeActionText">
            <i [class]="action.ActionUrls[0].Icon"></i>&nbsp;
            {{ action.Name | locale }}
          </li>
          <li nz-menu-item (click)="executeAction(action.ActionUrls[0])" *ngIf="action.ActionUrls.length == 1 && removeActionText">
            <i [class]="action.ActionUrls[0].Icon"></i>
          </li>
          <li nz-submenu *ngIf="action.ActionUrls.length > 1" [nzTitle]="action.Name | locale">
            <ul>
              <!-- <ng-container *ngFor="let url of action.ActionUrls"> -->
              <li *ngFor="let url of action.ActionUrls" (click)="executeAction(url)" nz-menu-item>
                <!-- <a (click)="executeAction(url)"> -->
                <i [class]="url.Icon"></i>&nbsp;
                {{ url.Text | locale }}
                <!-- </a> -->
              </li>
              <!-- </ng-container> -->
            </ul>
          </li>
        </ng-container>
          <li nz-menu-item *ngIf="ShowDownloadButton.ShowDownloadButton">
            <a (click)="download()"> {{downloadButtonTitle}}</a>
          </li>
      </ul>
    </nz-dropdown-menu>
  </ng-container>

  <ng-container *ngIf="!inLine && actionsExpanded && displayMode === 'table'" [ngTemplateOutlet]="menuTemplate">
  </ng-container>

  <ng-container *ngIf="inLine && recordIds != null && recordIds.length > 0">
    <ng-container [ngTemplateOutlet]="menuTemplate" *ngIf="innerWidth > 992">
    </ng-container>
    <ng-container [ngTemplateOutlet]="MobileViewMenu" *ngIf="innerWidth < 992">
    </ng-container>
  </ng-container>
</ng-container>
<ng-template #MobileViewMenu>
  <button nz-button nzType="primary" nz-dropdown [nzDropdownMenu]="menu" [nzPlacement]="'topRight'"
    class="mobile-view-menu-btn">
    <i class="far fa-bolt"></i>
  </button>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <ng-container *ngFor="let action of ungroupedActions">
        <li nz-menu-item (click)="executeAction(action.ActionUrls[0])" *ngIf="action.ActionUrls.length == 1 && !removeActionText">
          <i [class]="action.ActionUrls[0].Icon"></i>&nbsp;
          {{ action.Name | locale }}
        </li>
        <li nz-menu-item (click)="executeAction(action.ActionUrls[0])" *ngIf="action.ActionUrls.length == 1 && removeActionText">
          <i [class]="action.ActionUrls[0].Icon"></i>
        </li>
        <ng-container *ngIf="action.ActionUrls.length > 1">
          <li nz-submenu [nzTitle]="action.Name | locale">
            <ul>
              <li nz-menu-item *ngFor="let url of action.ActionUrls" (click)="executeAction(url)">
                <i [class]="url.Icon"></i>&nbsp;
                {{ url.Text | locale }}
              </li>
            </ul>
          </li>
        </ng-container>
      </ng-container>
      <ng-container *ngFor="let group of groupedActions">
        <li nz-submenu [nzTitle]="group.key | locale">
          <ul>
            <ng-container *ngFor="let action of group.actions">
              <li nz-menu-item *ngIf="action.ActionUrls.length == 1" (click)="executeAction(action.ActionUrls[0])">
                <i [class]="action.ActionUrls[0].Icon"></i>&nbsp;
                {{ action.Name | locale }}
              </li>
              <li nz-submenu *ngIf="action.ActionUrls.length > 1" [nzTitle]="action.Name | locale">
                <ul>
                  <li nz-menu-item *ngFor="let url of action.ActionUrls" (click)="executeAction(url)">
                    <i [class]="url.Icon"></i>&nbsp;
                    {{ url.Text | locale }}
                  </li>
                </ul>
              </li>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </nz-dropdown-menu>
</ng-template>

<ng-template #menuTemplate>
  <nz-button-group>
    <ng-container *ngFor="let group of groupedActions">
      <button nz-button nz-dropdown [nzDropdownMenu]="actionsMenu">
        {{ group.key | locale }}
        <i nz-icon nzType="down"></i>
      </button>
      <nz-dropdown-menu #actionsMenu="nzDropdownMenu">
        <ul nz-menu>
          <ng-container *ngFor="let action of group.actions">
            <li nz-menu-item *ngIf="action.ActionUrls.length == 1" (click)="executeAction(action.ActionUrls[0])">
              <i [class]="action.ActionUrls[0].Icon"></i>&nbsp;
              {{ action.Name | locale }}
            </li>
            <li nz-submenu *ngIf="action.ActionUrls.length > 1" [nzTitle]="action.Name | locale">
              <ul>
                <li nz-menu-item *ngFor="let url of action.ActionUrls" (click)="executeAction(action.ActionUrls[0])">
                  <i [class]="url.Icon"></i>&nbsp;
                  {{ url.Text | locale }}
                </li>
              </ul>
            </li>
          </ng-container>
        </ul>
      </nz-dropdown-menu>
    </ng-container>
    <ng-container *ngFor="let action of ungroupedActions">
      <button nz-button (click)="executeAction(action.ActionUrls[0])" *ngIf="action.ActionUrls.length == 1 && !removeActionText">
        <i [class]="action.ActionUrls[0].Icon"></i>&nbsp;
        {{ action.Name | locale }}
      </button>
      <button nz-button (click)="executeAction(action.ActionUrls[0])" *ngIf="action.ActionUrls.length == 1 && removeActionText">
        <i [class]="action.ActionUrls[0].Icon"></i>
      </button>
      <ng-container *ngIf="action.ActionUrls.length > 1">
        <button nz-button nz-dropdown [nzDropdownMenu]="actionsMenu">
          {{ action.Name | locale }}
          <i nz-icon nzType="down"></i>
        </button>
        <nz-dropdown-menu #actionsMenu="nzDropdownMenu">
          <ul nz-menu>
            <li nz-menu-item *ngFor="let url of action.ActionUrls" (click)="executeAction(url)">
              <i [class]="url.Icon"></i> &nbsp;
              {{ url.Text | locale }}
            </li>
          </ul>
        </nz-dropdown-menu>
      </ng-container>
    </ng-container>
  </nz-button-group>
</ng-template>
<nz-modal [(nzVisible)]="isTokenModalVisible" nzTitle="Document Link" [nzClosable]="true">
  <div *nzModalContent>
    <input nz-input type="text" [value]="tokenLink" />
  </div>
  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="copyTokenLink()">
      {{ "Copy" | locale }}
    </button>
    <button nz-button nzType="default" (click)="isTokenModalVisible = false">
      {{ "Close" | locale }}
    </button>
  </div>
</nz-modal>


<ng-template #extraComponent></ng-template>

<ng-template #attachmentsTemplate>
  <ng-container *ngIf="files && files.length; else emptyTemplate">
<div *ngFor="let file of files; let i=index" style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px;">
  <span style="width: 30px; text-align: left;">{{ i + 1 }}</span>

  <nz-input-group [nzAddOnAfter]="suffixIconSearch">
    <input type="text" nz-input [value]="file.FullFilePath.split('\\').pop()" readonly />
  </nz-input-group>

  <ng-template #suffixIconSearch>
    <i nz-icon nzType="download" nzTheme="outline" style="cursor:pointer" (click)="previewFile(file.FullFilePath)"></i>
  </ng-template>
</div>
</ng-container>
 <ng-template #emptyTemplate>
  <nz-empty
  nzNotFoundImage="simple"
   [nzNotFoundContent]="notFoundMessage">
</nz-empty>

</ng-template>
